// eslint-disable-next-line import/no-anonymous-default-export
export default {
  API_URL: process.env.REACT_APP_API_URL || "http://localhost:3333/api/",
  STATIC_URL: process.env.REACT_APP_STATIC_URL || "http://localhost:3333/",
};
